import React, { useMemo } from 'react';
import styled, { keyframes } from 'styled-components';

// Keyframes
const fall = keyframes`
  to {
    transform: translate3d(0, 120vh, 0);
  }
`;

const tailFade = keyframes`
  0%, 50% {
    height: var(--star-tail-length);
    opacity: 1;
  }
  70%, 80% {
    height: 0;
    opacity: 0.4;
  }
  100% {
    height: 0;
    opacity: 0;
  }
`;

const blink = keyframes`
  50% {
    opacity: 0.6;
  }
`;

const StarsWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
`;

const Star = styled.div`
  --star-tail-length: ${({ length }) => `${length}em`};

  position: absolute;
  left: ${({ left }) => left}vw;
  top: 0;
  width: 2px;
  height: ${({ length }) => length}em;
  color: var(--primary-color, #23afe7);
  background: linear-gradient(to bottom, transparent, currentColor); /* ← glow at bottom */
  border-radius: 50%;
  filter: drop-shadow(0 0 6px currentColor);
  transform: translate3d(0, -120vh, 0);
  animation:
    ${fall} ${({ duration }) => duration}s ${({ delay }) => delay}s linear infinite,
    ${tailFade} ${({ duration }) => duration}s ${({ delay }) => delay}s ease-out infinite;
  z-index: 9999;
  @media (max-width: 750px) {
    animation: ${fall} ${({ duration }) => duration}s ${({ delay }) => delay}s linear infinite;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: ${({ length }) => `calc(${length / 6}em / -2)`}; /* ← glow at bottom */
    width: 100%;
    height: ${({ length }) => length / 6}em;
    background: linear-gradient(to top, transparent, currentColor, transparent); /* ← fading upward */
    border-radius: inherit;
    animation: ${blink} 2s linear infinite;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

const ShootingStars = ({ count = 20 }) => {
  const stars = useMemo(() => {
    return Array.from({ length: count }).map((_, index) => ({
      id: index,
      length: (Math.random() * (7.5 - 5) + 5).toFixed(2), // em
      left: (Math.random() * 100).toFixed(2), // vw
      duration: (Math.random() * (12 - 6) + 6).toFixed(2), // sec
      delay: (-Math.random() * 6).toFixed(2), // sec
    }));
  }, [count]);

  return (
    <StarsWrapper>
      {stars.map(({ id, ...props }) => (
        <Star key={id} {...props} />
      ))}
    </StarsWrapper>
  );
};

export default ShootingStars;
